import { type ImgFormats, type Picture } from '@redneckz/wildless-cms-uni-blocks/lib/model/Picture';

export const normalizeImage = (image?: Queries.Maybe<Queries.ProductBlockImage>): Picture => {
  const { src, alt, format } = image ?? {};

  return src
    ? {
        src: src.childImageSharp?.gatsbyImageData.images.fallback?.src,
        // size: {
        //   width: src?.childImageSharp?.gatsbyImageData.width,
        //   height: src?.childImageSharp?.gatsbyImageData.height,
        // },
        format: (format ?? 'png') as ImgFormats,
        alt: alt ?? '',
      }
    : {};
};
